const LoginType = {
    BITKUB_NEXT: "bitkub_next",
    METAMASK: "metamask",
    KUB_WALLET: "kubwallet",
};

export const SUPPORTED_LOGIN_TYPES = Object.values(LoginType);

export const isValidLoginType = (type) => {
    return Boolean(type && SUPPORTED_LOGIN_TYPES.includes(type));
};

export default LoginType;